/* __next_internal_client_entry_do_not_use__ RoutingContext auto */ import * as React from "react";
export var RoutingContext = /*#__PURE__*/ React.createContext({
    locale: undefined,
    canonicalLocale: "en-US",
    localeCountryUrlPrefix: "",
    allowedRobotLocales: [],
    faireDirectBrandAlias: undefined,
    faireDirectBrandToken: undefined,
    Link: undefined,
    useSearchParams: undefined,
    useRouterOrHistory: undefined,
    usePathname: undefined
});
